<template>
    <JetFormSection @submitted="updateSettingIpp">
        <template #title>Komponen Gaji</template>

        <template #description>Setting komponen gaji</template>

        <template #form>
            <!-- Tarif IPP -->
            <div class="col-span-6 sm:col-span-4">
                <JetLabel for="tarif_ipp" value="Tarif IPP" />
                <Input
                    id="tarif_ipp"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.tarif_ipp"
                    autocomplete="tarif_ipp"
                />
                <JetInputError :message="form.errors.tarif_ipp" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <InertiaButtonSave
                :class="{ 'opacity-25': form.processing }"
                label="Simpan"
            />
        </template>
    </JetFormSection>
</template>

<script>
import { defineComponent } from "vue";
import JetFormSection from "@/Jetstream/FormSection";
import Input from "@/Components/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import InertiaButtonSave from "@/Components/InertiaButtonSave";

export default defineComponent({
    components: {
        JetFormSection,
        Input,
        JetInputError,
        JetLabel,
        InertiaButtonSave,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "PUT",
                tarif_ipp: this.$page.props.setting.tarif_ipp,
            }),
        };
    },
    methods: {
        updateSettingIpp() {
            this.form.post(route("setting.ipp.save"), {
                errorBag: "updateSettingIpp",
                preserveScroll: true,
                // onSuccess: () => (this.clearPhotoFileInput()),
            });
        },
    },
});
</script>
